'use client';

import Main from './Main';
import LoginForm from '../LoginForm/LoginForm';
import { observer } from 'mobx-react';
import { getStore } from '~/mobx/AppStore';
import Loading from '../Loading/Loading';

interface Props {
    isLoggedIn: boolean;
    loading: boolean;
    loadingText?: string;
    renderLoginForm: boolean;
}

function BallotPage(props: Readonly<Props>) {
    const { loading, loadingText, renderLoginForm } = props;

    if (loading) {
        return <Loading loadingText={loadingText} />;
    }

    if (renderLoginForm) return <LoginForm />;

    return <Main />;
}

const BallotPageWithStore = observer(() => {
    const { ballotStore, voteStore, previewStore } = getStore();
    const isLoggedIn = ballotStore.getIsLoggedIn();
    const isPreview = previewStore.isInitialized;
    const loading =
        (!ballotStore.isInitialized && !ballotStore.isElectionInitialized && !ballotStore.isStandAdminInitialized) ||
        voteStore.isVoteInProgress;
    const loadingText = voteStore.isVoteInProgress ? 'Stemmeseddel leveres. Vennligst vent…' : undefined;
    const noElectionActiveError = ballotStore.getNoActiveElectionError();

    let renderLoginForm = !isLoggedIn;
    if (noElectionActiveError?.isError) {
        renderLoginForm = true;
    }
    const submitVoteError = voteStore.voteStatus === 'error';
    if (submitVoteError || isPreview) {
        renderLoginForm = false;
    }

    return (
        <BallotPage
            renderLoginForm={renderLoginForm}
            isLoggedIn={isLoggedIn || isPreview}
            loading={loading}
            loadingText={loadingText}
        />
    );
});

export default BallotPageWithStore;
